import { v4 as uuidv4 } from 'uuid'
import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { toAletheiaItem } from './aletheiaItemFallback'
import { type DniAnalysisTransformer } from './transformers'

export const beginCheckoutTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'begin_checkout') return event
  const { currency = 'TWD', value = 0, items } = event.eventParams
  if (!items) return event
  const campaignCode = 'campaign_code' in event.eventParams ? event.eventParams.campaign_code : undefined
  /**
   * 給 Aletheia 去重複用的 UUID
   */
  const eventId = uuidv4()
  if (platform === AnalyticsPlatforms.META_PIXEL) {
    return {
      eventName: 'InitiateCheckout',
      eventParams: {
        content_ids: items.map(item => item.item_id).filter((id): id is string => id !== undefined),
        contents: items.map(item => ({
          id: item.item_id || 'None',
          quantity: item.quantity || 0,
        })),
        currency,
        value,
        num_items: items.length,
        campaign_code: campaignCode,
      },
      eventId,
    }
  }
  if (platform === AnalyticsPlatforms.ALETHEIA) {
    return {
      eventName: 'begin_checkout',
      eventParams: {
        ...event.eventParams,
        items: event.eventParams.items?.map(item => toAletheiaItem(item, 'begin_checkout')),
      },
      eventId,
    }
  }
  if (platform === AnalyticsPlatforms.OMNICHAT) {
    const products = items.map(item => ({
      id: item.item_id || '',
      quantity: item.quantity || 0,
      price: String(item.price || 0),
      brand: item.item_brand || '',
      name: item.item_name || '',
      variant: item.item_variant || '',
    }))
    return { eventName: 'checkout', eventParams: { items: products } }
  }
  if (platform === AnalyticsPlatforms.KLAVIYO) {
    return {
      eventName: 'Started Checkout',
      eventParams: {
        $event_id: eventId,
        $value: value,
        ItemNames: items.map(item => item.item_name).filter((name): name is string => !!name),
        Items: items.map(item => ({
          ProductID: item.item_id || undefined,
          ProductName: item.item_name || undefined,
          Quantity: item.quantity || undefined,
          Price: Number(item.price) || undefined,
          Variant: item.item_variant || undefined,
          Brand: item.item_brand || undefined,
          RowTotal: Number(item.price) * (item.quantity || 0) || undefined,
        })),
      },
    }
  }
  return event
}
